module.exports = __webpack_public_path__ + "static/media/45-philly.2934ba73.jpeg";